import React from 'react';
import { Box, CircularProgress } from '@mui/material';

interface AuthGuardedPublicBoundaryProps {
  authenticated: boolean;
  loading: boolean;
  authenticatedFallback: React.ReactNode;
  children: React.ReactNode;
}

/** Prevents signed-out content flashing while an existing session is recovering. */
export function AuthGuardedPublicBoundary({
  authenticated,
  loading,
  authenticatedFallback,
  children,
}: AuthGuardedPublicBoundaryProps) {
  if (loading) {
    return (
      <Box
        data-testid="auth-recovery-loading"
        sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}
      >
        <CircularProgress size={28} />
      </Box>
    );
  }
  if (authenticated) return <>{authenticatedFallback}</>;
  return <>{children}</>;
}
